import type { ReactNode } from 'react'
import React, { createContext, useContext } from 'react'
import { useParams } from '@fs/zion-router'
import type { PersonId } from '@fs/zion-tree-types'

const FocusPIDContext = createContext<PersonId | null>(null)

export const useFocusPID = (): PersonId | null => useContext(FocusPIDContext)

export default function FocusPIDProvider({ children }: { children: ReactNode }): JSX.Element {
  const { pid } = useParams()
  return <FocusPIDContext.Provider value={pid}>{children}</FocusPIDContext.Provider>
}
